import { Injectable } from '@angular/core';
import { AnalyticsService, AuthorizedApiService } from '@laasy/common-layout';
import { UserViewModel } from '../../models/user';
import { catchError, Observable, retry, tap, throwError } from 'rxjs';
import { ApiResponse } from '../../models/apiResponse';
import { SignupSurveyService } from 'src/app/modules/auth/service/signup-survey.service';
import { SegmentEvent } from '../../utilities/constants';
import { VerifyEmailService } from '@laasy/common-layout';

@Injectable({
  providedIn: 'root'
})
export class AuthIntegrationService {
  constructor(
    private readonly apiService: AuthorizedApiService,
    private signupSurvey:SignupSurveyService,
    private analyticsService: AnalyticsService,
    private verifyEmailService:VerifyEmailService
  ) {}

  addSignupUser(userRequest: UserViewModel): Observable<ApiResponse> {
    return this.apiService.post<ApiResponse>(
      'user/api/usermanagement/signup',
      userRequest
    ).pipe(tap(async (x:any)=>{
      this.verifyEmailService.invalidateVerifyEMailCache()
      this.analyticsService.segmentTrackEvent( { email: userRequest.email}, SegmentEvent.signupSuccess);
      if(userRequest?.survey) this.signupSurvey.postSurveyResponse(userRequest?.survey)
      }),
      catchError(error => {
        this.analyticsService.segmentTrackEvent( { email: userRequest.email, error:error}, SegmentEvent.signupError);
        return throwError(()=>error);
      })
    );
  }

  checkUserByUserId(userId: string): Observable<ApiResponse> {
    return this.apiService.get<ApiResponse>(
      `user/api/usermanagement/verifyUserByUserId?userid=${userId}`
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  cancelUserMembership(userId: string): Observable<ApiResponse> {
    return this.apiService.delete<ApiResponse>(
      `user/api/account/cancelMembership`
    );
  }
}
